import * as React from "react";
import {
  Text,
  Image,
  View,
  StyleSheet,
  Platform,
  TouchableOpacity,
  Linking
} from "react-native";
import GlobalStyles from "../../components/GlobalStyles.js";
import { useNavigation } from "@react-navigation/native";
import StatusBar from "../../components/headers/StatusBar";
import { modifyPartner } from "../../redux/actions/PartnerActions.js";
import { useSelector } from "react-redux";
import { shellInitialSignup } from "../../redux/actions/PartnerActions.js";
import { user_force_refresh } from "../../redux/actions/UserActions";
import GenericButton from "../../components/GenericButton.js";
import Colors from "../../utilities/Color.js";

export default function ConsentScreen() {
  const BGimage = require("../../assets/res/blue_bg.png");
  const MenuLogo = require("../../assets/res/Aura_Alpha_Reversed_BlueBG.gif");
  const shellLogo = require("../../assets/images/shell/shellIcon.png");
  const navigation = useNavigation();
  const givenName = useSelector((state) => state.user.userData.subscriberDetails.givenName) || false;
  const familyName = useSelector((state) => state.user.userData.subscriberDetails.familyName) || false;
  const email = useSelector((state) => state.user.userData.subscriberDetails.email) || false;
  const phone = useSelector((state) => state.user.userData.subscriberDetails.phone) || false;
  const refId = useSelector(
    (state) => state.user.userData.subscriberDetails.referFriendId
  );
  return (
    <View style={GlobalStyles.containerN}>
      <View style={GlobalStyles.backgroundContainer}>
        <Image style={GlobalStyles.backgroundImage} source={BGimage} />
      </View>
      <View style={styles.headerContainer}>
        <View style={styles.backButtonContainer}>
          <StatusBar data="B_T" />
        </View>
        <View style={styles.mainMenuLogoContainer}>
          <Image style={styles.mainMenuLogo} source={MenuLogo} />
        </View>
        <View style={styles.forwardButtonContainer}>
        </View>
      </View>
      <View>
        <View style={styles.bodyContainerFull}>
          <View style={styles.modalContainerF}>
            <View style={styles.modalContainer}>
              <View style={styles.headerTextP}>
                <View style={styles.fuelPartnerTextContainer}>
                  <Text style={styles.fuelPartnerTextStyle}>
                    Fuel Partner
                  </Text>
                </View>
                <View style={styles.ShellLogoContainer}>
                  <Image style={styles.shellLogo} source={shellLogo} />
                </View>
                <View style={styles.termTextContainer}>
                  <Text style={styles.textStyle}>
                    <Text style={styles.textStyle}>
                      By activating this offer you agree to&nbsp;
                      <Text style={[styles.textStyle, { textDecorationLine: 'underline' }]}
                        onPress={() => {
                          Platform.OS !== "web"
                            ? Linking.openURL("https://aura.club/promotional-terms-and-conditions")
                            : window.open("https://aura.club/promotional-terms-and-conditions", "_blank");
                        }}>
                        Promotional Terms and Conditions,
                      </Text>
                      &nbsp;including the disclosure of your
                      contact details and transaction
                      data for marketing purposes with
                      Viva Energy (Shell licensee) in line
                      with&nbsp;
                      <Text style={[styles.textStyle, { textDecorationLine: 'underline' }]}
                        onPress={() => {
                          Platform.OS !== "web"
                            ? Linking.openURL("https://www.vivaenergy.com.au/contact/privacy-policy")
                            : window.open("https://www.vivaenergy.com.au/contact/privacy-policy", "_blank");
                        }}>
                        Viva Energy Privacy Policy.
                      </Text>
                    </Text>
                  </Text>
                </View>
                <View style={styles.buttonContainer}>
                  {/* This commented part can be removed in 22/10/23 */}
                  {/* <TouchableOpacity
                    style={styles.agreeSubmitButtonStyle}
                    activeOpacity={0.5}
                    onPress={() => {
                      var apiData = {
                        partnerName: "Shell",
                        // "partnerStatus" : "active",
                        partner_id: refId,
                        partner_validation_type: "N/A",
                        partner_type: "direct",
                        sub_partner_type: "Shell",
                      };

                      apiData.payload = {
                        partner_custom_field_A: "",
                        partner_custom_field_B: "",
                        partner_custom_field_C: "",
                        partner_custom_field_D: "",
                        partner_custom_field_E: "",
                        partner_custom_field_F: "",
                        partner_custom_field_G: "",
                        partner_custom_field_H: "",
                        partner_custom_field_I: "",
                        partner_custom_field_J: "",
                      };

                      var shellData = {
                        "firstName": givenName,
                        "lastName": familyName
                      };
                      if (email) shellData['emailAddress'] = email;
                      if (phone != "0") shellData['phoneContacts'] = { 'phoneNumber': phone };

                      modifyPartner("Shell", 1, apiData);
                      shellInitialSignup(shellData);
                      setTimeout(() => user_force_refresh(), 3000); // delaying already existing force refresh a few seconds! 
                      navigation.navigate("RedeemLanding");
                    }}
                  >
                    <Text style={styles.buttonTextStyle}>I AGREE</Text>
                  </TouchableOpacity> */}
                  {/* <TouchableOpacity
                    style={styles.notNowSubmitButtonStyle}
                    activeOpacity={0.5}
                    onPress={() => navigation.navigate("MainMenu")}
                  >
                    <Text style={styles.buttonTextStyle}>NOT NOW</Text>
                  </TouchableOpacity>  */}
                  {/* <View style={{ marginTop: 40, flexDirection: "row" }}> */}
                  <GenericButton
                    buttonText='I AGREE'
                    onPress={() => {
                      var apiData = {
                        partnerName: "Shell",
                        // "partnerStatus" : "active",
                        partner_id: refId,
                        partner_validation_type: "N/A",
                        partner_type: "direct",
                        sub_partner_type: "Shell",
                      };

                      apiData.payload = {
                        partner_custom_field_A: "",
                        partner_custom_field_B: "",
                        partner_custom_field_C: "",
                        partner_custom_field_D: "",
                        partner_custom_field_E: "",
                        partner_custom_field_F: "",
                        partner_custom_field_G: "",
                        partner_custom_field_H: "",
                        partner_custom_field_I: "",
                        partner_custom_field_J: "",
                      };

                      var shellData = {
                        "firstName": givenName,
                        "lastName": familyName
                      };
                      if (email) shellData['emailAddress'] = email;
                      if (phone != "0") shellData['phoneContacts'] = { 'phoneNumber': phone };

                      modifyPartner("Shell", 1, apiData);
                      shellInitialSignup(shellData);
                      setTimeout(() => user_force_refresh(), 3000); // delaying already existing force refresh a few seconds! 
                      navigation.navigate("RedeemLanding");
                    }}
                    buttonWidth={120}
                    borderWidth={1}
                  />
                  <GenericButton
                    buttonText='NOT NOW'
                    onPress={() => navigation.navigate("MainMenu")}
                    buttonColor={null}
                    buttonWidth={120}
                    borderWidth={1}
                    borderColor={Colors.DARKGRAY}
                  />
                  {/* </View> */}
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>
    </View >
  )
}
const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: "row",
    height: 150,
  },
  backButtonContainer: {
    flex: 1,
    //paddingLeft: 10
  },
  forwardButtonContainer: {
    flex: 1,
    //paddingLeft: 10
  },
  mainMenuLogoContainer: {
    flex: 5,
    alignSelf: "center",
    alignItems: "center",
    //paddingRight: 90,
    paddingTop: 30,
    paddingLeft: 10,
  },
  mainMenuLogo: {
    height: 70,
    width: 128,
  },
  bodyContainerFull: {
    flex: 1,
    flexDirection: "column",
    paddingTop: 30,
    paddingLeft: 0,
    paddingRight: 0,
    alignSelf: "center",
    width: "100%"
  },
  modalContainerF: {
    marginTop: 50,
    paddingRight: 30,
    paddingLeft: 30,
    alignItems: "center",
    alignSelf: "center",
  },
  modalContainer: {
    alignItems: "center",
    height: 400,
    backgroundColor: "#FFFFFF",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 60,
    borderTopLeftRadius: 60,
    borderTopRightRadius: 60,
    paddingTop: 30,
    paddingRight: 30,
    paddingLeft: 30,
    width: 330,
  },
  textStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 15,
    color: "black",
    textAlign: "left",
    marginBottom: 5,
    maxWidth: 300,
  },
  fuelPartnerTextContainer: {
    alignItems: "center",
    marginTop: -10
  },
  fuelPartnerTextStyle: {
    fontFamily: "montserrat-regular",
    textAlign: "center",
    color: "#757575",
    fontSize: 14,
    fontWeight: "bold"
  },
  buttonTextStyle: {
    color: "#000000",
    textAlign: "center",
    alignSelf: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    fontWeight: "bold"
  },
  buttonContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    marginTop: 40
  },
  agreeSubmitButtonStyle: {
    marginTop: 40,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: "#FFC72C",
    borderRadius: 30,
    alignItems: "center",
  },
  notNowSubmitButtonStyle: {
    marginTop: 40,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "#FFFFFF",
    borderWidth: 1.5,
    borderColor: "#808080",
    borderRadius: 20,
    alignItems: "center",
  },
  ShellLogoContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20
  },
  termTextContainer: {
    marginTop: 20,
    alignItems: "center",
  },
})